<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="280"
      transition="slide-y-transition"
      offset-y rounded="xl"
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon class="user-menu-btn">
          <v-badge
            v-if="currentUser.superAdmin || currentUser.isAdmin"
            avatar
            overlap
            color="primary"
            offset-x="8"
            offset-y="8"
          >
            <template v-slot:badge>
              <v-avatar size="20">
                <v-icon small color="white" v-if="currentUser.superAdmin">
                  mdi-crown
                </v-icon>

                <v-icon small color="white" v-else-if="currentUser.isAdmin">
                  mdi-shield-account
                </v-icon>
              </v-avatar>
            </template>

            <v-avatar size="40" class="user-avatar">
              <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" />
              <img v-else src="@/assets/images/user.jpeg" alt="User" />
            </v-avatar>
          </v-badge>

          <v-avatar v-else size="40" class="user-avatar">
            <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" />
            <img v-else src="@/assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-btn>
      </template>

      <v-card class="user-menu-card">
        <div class="user-menu-header">
          <v-avatar size="54" class="profile-avatar">
            <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" />
            <img v-else src="@/assets/images/user.jpeg" alt="User" />
          </v-avatar>

          <div class="profile-info">
            <div class="profile-name">
              {{ currentUser.name }}
            </div>

            <div class="profile-email">
              {{ currentUser.email }}
            </div>

            <v-chip
              x-small
              class="mt-2 font-weight-bold"
              :color="roleColor"
              :text-color="roleTextColor"
            >
              {{ roleLabel }}
            </v-chip>
          </div>
        </div>

        <div class="location-box">
          <div class="location-label">Location Code</div>
          <div class="location-code">
            {{ currentBusiness ? currentBusiness.code : "" }}
          </div>
        </div>

        <v-list dense class="menu-list">
          <v-list-item @click="$router.push('/account')">
            <v-list-item-icon>
              <v-icon small>mdi-account-circle-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>My Account</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-card-actions class="menu-actions">
          <ChangePassword :UserId="currentUser.id" />

          <v-spacer />

          <v-btn color="primary" text to="/logout">
            {{ $t("buttons.logout") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import menuService from "../service.js";
import ChangePassword from "../../User/components/ChangePassword";

export default {
  name: "layout-menu",

  components: {
    ChangePassword,
  },

  data() {
    return {
      rating: 0,
      fav: true,
      menu: false,
      message: false,
      hints: true,
    };
  },

  computed: {
    ...mapGetters("global", ["currentUser", "currentBusiness"]),

    roleLabel() {
      if (this.currentUser.superAdmin) {
        return "Super Admin";
      }

      if (this.currentUser.isAdmin) {
        return "Admin";
      }

      return "User";
    },

    roleColor() {
      if (this.currentUser.superAdmin) {
        return "amber lighten-5";
      }

      if (this.currentUser.isAdmin) {
        return "blue lighten-5";
      }

      return "grey lighten-4";
    },

    roleTextColor() {
      if (this.currentUser.superAdmin) {
        return "amber darken-4";
      }

      if (this.currentUser.isAdmin) {
        return "blue darken-3";
      }

      return "grey darken-3";
    },
  },

  methods: {
    editProfile() {
      this.$router.push(`/user/edit/${this.currentUser.userID}`);
    },

    getRating() {
      menuService.getRating(this.currentUser.userID).then((result) => {
        this.rating = result.data[0].average;
      });
    },
  },
};
</script>

<style scoped>
.user-menu-btn {
  border-radius: 14px;
}

.user-avatar,
.profile-avatar {
  border: 2px solid #e2e8f0;
}

.user-menu-card {
  border-radius: 18px;
  overflow: hidden;
  min-width: 300px;
}

.user-menu-header {
  padding: 18px;
  display: flex;
  gap: 12px;
  align-items: center;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.profile-info {
  min-width: 0;
  text-align: left;
}

.profile-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 190px;
}

.profile-email {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 190px;
}

.location-box {
  margin: 14px 16px 8px;
  padding: 12px;
  border-radius: 14px;
  background: #f8fafc;
}

.location-label {
  font-size: 11px;
  color: #64748b;
}

.location-code {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  margin-top: 2px;
}

.menu-list {
  padding: 4px 8px 8px;
}

.menu-actions {
  padding: 10px 14px;
}

.menu-img {
  border-radius: 12px;
  width: 45px;
  height: 48px;
}
</style>